import AccountModel from './accountModel';
import Service from '../services/services';
import { states } from '../helpers/helpers';
import ErrorController from '../controllers/errorController';
import { utagLink } from '../../../core/js/utils/analyticsUtils';

class StoreModel extends AccountModel{
    constructor() {
        super();
        this.stores = {};
        this.queuedStores = [];
        this.favoriteStores = [];
        this.initialized = {
            favoriteStores : {}
        };
        this.mapData = '';
    }

    get(property){
        return this[property];
    }

    /**
     * Build out favorite stores list on page load, Called in profileController Render
     * @param  {array} favoriteStores
     * @return {string} returns a nonsense variable (it doesn't matter)
     */
    storeInit(favoriteStores) {
        return new Promise((resolve,reject)=>{
            //fetch stores from misl based on store ids returned from profile
            this.fetchMislStores(favoriteStores)
                //clean up dirty arrays ie: results.data
                .then( dirtyStoreArray => {
                    return this.cleanStoreArray(dirtyStoreArray)
                })
                //store that array into relationships
                .then(cleanStoreArray => {
                    return resolve(this.setFavoriteStores(cleanStoreArray));
                })
        })
    }

    /**
     * Removes store from preferences.global.favorites
     * @param {object} model
     * @param {string} selector
     * @param {string} modelProperty
     * @param {string} session
     * @param {string} serviceMethod
     * @param {object} viewModel
     * @param {object} profileModel
     */
    removeStore(model,selector,params,session,serviceMethod,viewModel, profileModel){
        this.createLoader();
        return new Promise((resolve,reject)=>{
            this.getStoreNumber(selector)
                .then(storeNumber => {
                    return this.deleteStoreArray(storeNumber, profileModel);
                })
                .then(queuedStores => {
                    return this.updateFavoriteStores(queuedStores, session, serviceMethod, profileModel, true);
                }).then(updateService => {
                    return resolve(true)
                })
        })
    }

    /**
     * Submit stores from  queueStore array, clear it & then clear stores results array.
     * @param {object} model
     * @param {string} selector
     * @param {string} modelProperty
     * @param {string} session
     * @param {string} serviceMethod
     * @param {object} viewModel
     * @param {object} profileModel
     */
    submitStores(model,selector,params,session,serviceMethod,viewModel, profileModel){
        this.createLoader();
        return new Promise((resolve,reject)=>{
            this.fetchQueuedStores()
                .then(queuedStores => {
                    //this isnt right fix
                    return this.updateFavoriteStores(queuedStores, session, serviceMethod, profileModel);
                })
            //clear queued stores
                .then(storeArray => {
                    return this.set(this,[], 'queuedStores', true);
                })
            //clear stores
                .then(storeArray => {
                    return this.set(this,[], 'stores', true);
                })
                .then(model =>{
                    return resolve(true);
                })
                .catch(error => { console.log(error) })
                    })
    }

    /**
     * Get search string from input, geocode it, and fetch stores from MISL
     * @param {object} model
     * @param {string} selector
     * @param {string} modelProperty
     * @param {string} session
     * @param {string} serviceMethod
     * @param {object} viewModel
     * @param {object} profileModel
     */
    fetchStores(model,selector,params,session,serviceMethod,viewModel, profileModel) {
        this.createLoader();
        let mapCoords;
        let searchString;
        return new Promise((resolve,reject) => {
            this.getAddress(selector)
            //Geocode a string into coordinates
                .then(address => {
                    console.log("addr: " + address);
                    searchString = address;

                    utagLink(
                        {
                            cmElem_a13 : searchString,
                            event_type: "element",
                            element_id: 'SEARCH_STORE',
                            element_category: 'MY_ACCT:ACCT_SETTINGS'
                        },
                        false
                    );

                    return super.getGeocode(address, serviceMethod);
                })
                .then(coords => {
                    mapCoords = coords;
                    console.log("fetch stores: coords");
                    return super.buildMap(coords, serviceMethod);
                })
                .then(map => {
                    console.log("fetch stores: ", map);

                    return Promise.resolve(super.setData(map,'mapData',true));
                })
            //want stores for an entire state? if Match abb or full state name return abr
                .then(model => {
                    return this.stateCheck(searchString);
                })
            //send coordinates or state abbreviation to MISL
                .then(isState => {
                    return this.getStoresMisl(mapCoords, isState);
                })
                .then(stores => {
                    return this.purgeExistingStores(stores.data.results, profileModel);
                })
                .then(stores => {
                    return this.set(this,stores, 'stores',true);
                })
                .then(model =>{
                    return resolve(model);
                })
                .catch(error => {
                    if(error.status === undefined || error.status === 'undefined' || error.status === '') {
                        // An invalid input doesn't return a status from MISL.
                        // The value returned is error === "Error: no stores"
                        error.status = 400;
                        error.data = {};
                        error.data['code'] = "NO_STORES";
                        return resolve(ErrorController.handleErrors(error, profileModel, viewModel, this));
                    } else {
                        // Incase we need to fail gracefully with unknown error
                        resolve(true);
                    }
                })
                    })
    }

    /**
     * return checked inputs array
     * @return {array}
     */
    fetchQueuedStores(){
        let stores = [];

        jQuery('.js-account-select-profile-store input:checked').each((index, value) => {
            stores.push(jQuery(value).parent().data('store-id'));
        });

        return new Promise(function(resolve, reject){
            resolve(stores);
        });
    }

    /**
     * For each storeid in favorite store array look it up in MISL
     * @param  {array}
     * @return {object}
     */
    fetchMislStores(storeIdArray) {
        storeIdArray = this.sanitizeStoreArray(storeIdArray);
        if(Object.keys(this.initialized.favoriteStores).length === 0 || this.initialized.favoriteStores.serviceRan === false){
            let storePromises = [];
            let queryParam = '';
            for (let i = 0; i < storeIdArray.length; i++) {
                queryParam += storeIdArray[i] + '|';
            }
            storePromises.push(this.getAllStores(queryParam.slice(0,-1)));
            return Promise.all(storePromises)
        } else{
            //data has already been retrieved and set
            return new Promise(function(resolve,reject){resolve('done')});
        }
    }

    /**
     * Get the store number from data-store-id
     * @param  {object}
     * @return {string}
     */
    getStoreNumber(selector){
        return new Promise(function(resolve, reject){
            resolve(jQuery(selector).data( "store-id" ));
        })
    }

    /**
     * Called from ProfileController, Cleans up dirty store array from MISL
     * @param  {array}
     * @return {array}
     */
    cleanStoreArray(storeArray){
        if(storeArray === 'done'){
            //data already set
            return new Promise(function(resolve, reject){ resolve('done') });
        }else {
            return new Promise(function(resolve, reject){
                let cleanArray = [];
                const storeData = _.get(storeArray[0], 'data.results', []);
                for (let i = 0; i < storeData.length; i++){
                    cleanArray.push(storeData[i])
                }
                resolve(cleanArray);
            })
        }

    }

    /**
     * Called from ProfileController, sets favorite stores in relationships.
     * @param  {array}
     */
    setFavoriteStores(storeArray){
        if(storeArray === 'done'){
            //data is set
            return new Promise(function(resolve, reject){ resolve('done') });
        }
        else {
            let _this = this;
            return new Promise((resolve,reject)=>{
                super.setInitialized('favoriteStores',true, false);
                resolve(_this.set(_this,storeArray, 'favoriteStores',true));

            })
        }
    }

    /**
     * Called from fetchStores, if a store in store results is already a favorite store purge it out
     * so user cannot add it again.
     * @param  {array}
     * @param  {object}
     * @return {array}
     */
    purgeExistingStores(storeArray, profileModel){
        var _this = this;
        storeArray = storeArray.slice();
        return new Promise(function(resolve,reject){

            if(!profileModel.preferences.global.favoriteStores) {
                profileModel.preferences.global.favoriteStores = []
            }

            let favoriteStores = profileModel.preferences.global.favoriteStores.slice();

            for (let i = 0; i < storeArray.length; i++) {
                if(_this.arrayContains(storeArray[i].storeNumber, favoriteStores)){
                    storeArray.splice(i, 1);
                }
            }
            resolve(storeArray);
        })
    }

    //this should reference helpers
    arrayContains(value, array){
        for (let i = 0; i < array.length; i++) {
            if (value === array[i]){
                return true;
            }
        }
        return false;
    }

    /**
     * Submit geocode coordinates to MISL service
     * @param {object} coordinates
     */
    getStoresMisl(coordinates,state){
        if(state){
            return Service.getStoresState(state)
        } else {
            return Service.getStores(coordinates)
        }
    }

    /**
     * Check serachValue against state array,
     * If true, return that states Abreviation
     */
    stateCheck(searchValue){
        let statesArray = states();
        let isState = false;
        for(let i = 0;i < statesArray.length;i++){
            if(statesArray[i].name == searchValue.toLowerCase() || statesArray[i]['alpha-2'] == searchValue.toUpperCase()){
                isState = statesArray[i]['alpha-2'];
            }
        }
        return Promise.resolve(isState)
    }

    /**
     * Get MISL store data for all stores
     * @param {string} storeId
     */
    getAllStores(queryParam){
        return Service.getAllStores(queryParam)
    }

    deleteStoreArray(storeNumber, profileModel){
        return new Promise(function(resolve, reject){
            let favoriteStores = profileModel.preferences.global.favoriteStores.slice();
            for (let i = 0; i < favoriteStores.length; i++) {
                if(favoriteStores[i] == storeNumber){
                    favoriteStores.splice(i, 1);
                }
            }
            resolve(favoriteStores)
        })
    }

    /**
     * Concat queued stores and current favorite stores
     * @param  {array} queuedStores  [description]
     * @param  {string} session         [description]
     * @param  {[type]} serviceMethod [description]
     * @param  {object} profileModel  [description]
     * @param  {boolean} isdelete  [description]
     * @return {array}               [description]
     */
    updateFavoriteStores(queuedStores, session, serviceMethod, profileModel, isdelete){
        //if we're removing stores the array is already concat
        let concatStores =  isdelete ? queuedStores :  this.sanitizeStoreArray(profileModel.preferences.global.favoriteStores.concat(queuedStores));
        //put array in correct format for put
        let favoriteStores = {favoriteStores: concatStores};
        super.setInitialized('favoriteStores',false, false);
        profileModel.setInitialized('preferences', false, profileModel.initialized.preferences.postNeeded);
        return this.updateStoreData(favoriteStores,session,serviceMethod,profileModel);
    }

    /**
     * A safety to make sure array contains real strings not objects or undefined
     * @param  {array} storeArray
     * @return {array}
     */
    sanitizeStoreArray(storeArray) {
        if (!storeArray) {
            return [];
        }

        let sanitizedStores = [];
        for(let i = 0; i < storeArray.length; i++){
            if(storeArray[i] !== undefined && typeof storeArray[i] == 'string' && storeArray[i] !== 'string') {
                sanitizedStores.push(storeArray[i])
            }
        }
        return sanitizedStores
    }

    updateStoreData(model,session,serviceMethod,profileModel, viewModel){
        return Service[serviceMethod](model,session,profileModel, viewModel);
    }

    getAddress(selector){
        return new Promise(function(resolve, reject){
            resolve(selector.parents('form').find('input[type=text]').val());
        });
    }

    set(model, data,prop,multipleValues){
        return new Promise((resolve, reject)=>{
            if(true){
                if(typeof model != 'undefined'){
                    resolve(super.setData(data,prop,multipleValues));
                }
                else{
                    reject(Error('No profile model found to set'));
                }
            }
            else{
                resolve(model);
            }
		    });
	  }

    attachMap(DOM) {
        console.log("MapData: ", this.mapData);

        if(this.mapData != '') {
            // Only show the map if the brand inserts a map container
            if (jQuery('#map_container')) {
                jQuery('#map_container').html(this.mapData.mapElement);
                google.maps.event.trigger(this.mapData.map,"resize");
            }
        }
        return Promise.resolve(DOM);
    }

}

let Stores = new StoreModel();

export default Stores;
